import PropTypes from "prop-types";
import InputTextarea from "../input-area/InputTextarea";
import FormInputWrapper from "../form/FormInputWrapper";
import { useFormInput } from "./utils";

const TextArea = ({
    name,
    validations,
    label,
    description,
    helpText,
    className,
    ...rest
}) => {
    const { wrapperProps, inputProps } = useFormInput({
        name,
        validations,
        isControlled: true,
    });

    return (
        <FormInputWrapper
            {...{ label, description, helpText, className }}
            {...wrapperProps}
        >
            <InputTextarea {...rest} {...inputProps} />
        </FormInputWrapper>
    );
};

TextArea.propTypes = {
    name: PropTypes.string.isRequired,
    validations: PropTypes.object,
    label: PropTypes.string,
    description: PropTypes.string,
    helpText: PropTypes.string,
    className: PropTypes.string,
};

export default TextArea;
